import React from 'react';
import moment from 'moment';
import View from './view';
import swal from 'sweetalert';

import { _AVATAR_ } from '../../../../config/defaults';

import Server from '../../../../services/Server';
import GeneratePassword from '../../../../services/passwordGenerator';

import cryptFunctions from '../../../../services/cryptPassword';

import md5 from 'js-md5';

let _showDataSubscriber = 0;

const SubscriberData = ({
	showDataSubscriber = 0,
	selectedUser,
	subscribersTemplate,
	firebase,
	eventId,
	event,
	updateLocalUser,
	currentUser = {},
	blockName = false,
}) => {
	const [isVisible, setVisibility] = React.useState(false);
	const [isLoading, setLoadingStatus] = React.useState(false);
	const [showPassword, setPasswordVisibility] = React.useState(false);
	const [userData, setUserData] = React.useState([]);
	const [tmpProfileIcon, setTempProfileIcon] = React.useState(false);

	const { uid, customLogo = false } = currentUser;

	const hide = () => {
		setVisibility(!isVisible);
	};

	React.useEffect(() => {
		if (!isVisible) {
			setTempProfileIcon(false);
		}
	}, [isVisible]);

	const handleShowPassword = (e) => {
		e.preventDefault();

		setPasswordVisibility(!showPassword);
	};

	const onChangePhoto = (file) => {
		setLoadingStatus(true);
		const fd = new FormData();
		fd.append('image', file);
		const _tmpId = GeneratePassword(25, true);

		const userId = selectedUser.id ? selectedUser.id : _tmpId;

		if (currentUser.isAnonymous && event.privacity === 'PUBLIC') {
			fd.append('folder', 'anoymousProfiles');
			const saved_data = localStorage.getItem('anonymous_data');
			if (saved_data) {
				let jsonSaved_Data = JSON.parse(saved_data);
				fd.append('name', jsonSaved_Data.customUid);

				Server.sendGlobalPicture(fd).then((response) => {
					setTempProfileIcon(response.data.path);
					localStorage.setItem(
						'anonymous_data',
						JSON.stringify({ ...jsonSaved_Data, hasCustomProfile: true })
					);

					updateLocalUser({
						photoURL: `${
							response.data.path
						}?d=${new Date().getUTCMilliseconds()}`,
					});
					setLoadingStatus(false);
				});
			}
		} else {
			Server.sendEventProfileIcon(userId, selectedUser.id, fd)
				.then((response) => {
					const { data = {} } = response;

					let { path } = data;

					if (typeof path === 'string') {
						path += '?' + moment().unix();
					}

					if (selectedUser.id === undefined) {
						setTempProfileIcon(path);
					} else {
						firebase.subCollection.update(
							'events',
							eventId,
							'subscribers',
							selectedUser.id,
							{ photoURL: path }
						);
					}
					setLoadingStatus(false);
				})
				.catch((error) => {
					setLoadingStatus(false);
					console.error(error);
				});
		}
	};

	const onSave = (e) => {
		e.preventDefault();
		setLoadingStatus(true);
		const el = e.target.elements;
		const data = {};
		for (var _elidx in el) {
			if (
				el[_elidx].name !== undefined &&
				el[_elidx].value !== undefined &&
				el[_elidx].name !== ''
			) {
				data[el[_elidx].name] = el[_elidx].value;
			}
		}

		if (event.privacity === 'PUBLIC') {
			const saved_data = localStorage.getItem('anonymous_data');
			if (saved_data) {
				let jsonSaved_Data = JSON.parse(saved_data);
				localStorage.setItem(
					'anonymous_data',
					JSON.stringify({ ...jsonSaved_Data, ...data })
				);
				updateLocalUser(data);
				setLoadingStatus(false);

				hide();
			}
		} else {
			if (!data.code) {
				data.code =
					GeneratePassword(4, true, 'text') +
					GeneratePassword(4, true, 'number');
			}

			if (data.code.length < 5) {
				setLoadingStatus(false);
				swal('Error', 'El código debe tener al menos 6 caracteres');
				return false;
			}

			const { login_methods = {} } = event,
				{
					code = false,
					email = false,
					facebook = false,
					google = false,
					twitter = false,
				} = login_methods;

			const onlyCode = code && !email && !facebook && !google && !twitter;

			if (selectedUser.displayName === undefined) {
				data['photoURL'] = tmpProfileIcon !== false ? tmpProfileIcon : _AVATAR_;
				data['name'] = data.displayName;
				data['lastname'] = '';

				const eventData = {
					id: event.id,
					name: event.name,
					url: event.url,
					startDate: event.startDate.format('DD [de] MMM [de] YYYY, HH:mm'),
					gmt: event.gmt,
					uid: uid,
					hasCustomBrand: customLogo,
					onlyCode,
					hasAccessCode: code,
				};

				Server.createSubscriber(data, eventData)
					.then(() => {
						swal({
							title: '',
							text: 'El registro ha sido creado',
							icon: 'success',
							buttons: false,
							dangerMode: false,
						});
						setLoadingStatus(false);
						hide();
					})
					.catch((err) => {
						swal({
							title: '',
							text: err.response.data,
							icon: 'error',
							buttons: true,
							dangerMode: true,
						});

						setLoadingStatus(false);
					});
			} else {
				let _password = '';
				if (el.password) {
					_password = cryptFunctions.encode(el.password.value.trim());
				}
				let _code = '';
				if (code && el.code) {
					_code = cryptFunctions.encode(el.code.value.trim());
					data['code'] = _code;
					data['md5_code'] = md5(md5(md5(el.code.value)));
				} else {
					delete data.md5_code;
					delete data.code;
				}

				if (email && el.password) {
					data['password'] = _password;
					data['md5_password'] = md5(md5(md5(el.password.value.trim())));
				} else {
					delete data.password;
					delete data.md5_password;
				}

				firebase.subCollection
					.update('events', eventId, 'subscribers', selectedUser.id, data)
					.then(() => {
						swal({
							title: '',
							text: 'El registro ha sido actualizado',
							icon: 'success',
							buttons: false,
							dangerMode: false,
						});
						setLoadingStatus(false);
					})
					.catch((error) => {
						console.error(error);
						swal({
							title: '',
							text: 'Hubo un error al intentar actualizar',
							icon: 'error',
							buttons: false,
							dangerMode: true,
						});
						setLoadingStatus(false);
					});
			}
		}
	};

	React.useEffect(() => {
		if (showDataSubscriber > _showDataSubscriber) {
			_showDataSubscriber = showDataSubscriber;
			setVisibility(true);
			setPasswordVisibility(false);
		}
	}, [showDataSubscriber]);

	React.useEffect(() => {
		const _tmp = [];
		for (var index in selectedUser) {
			if (index === 'password') {
				let _password = cryptFunctions.decode(selectedUser[index]);

				_tmp.push({
					index: 'password',
					label: 'password',
					value: _password,
					type: 'password',
				});
			} else {
				_tmp.push({
					index,
					label: index,
					value: selectedUser[index],
					type: 'text',
				});
			}
		}
		setUserData(_tmp);
	}, [selectedUser]);

	if (isVisible) {
		const _userData = [];

		const { login_methods = {} } = event,
			{ code = false, email = false } = login_methods;

		if (selectedUser.displayName === undefined) {
			_userData.push({
				index: 'displayName',
				label: 'displayName',
				value: '',
				type: 'text',
				required: true,
			});

			_userData.push({
				index: 'email',
				label: 'Correo Electrónico',
				value: '',
				type: 'email',
				required: code === false,
			});

			if (email) {
				_userData.push({
					index: 'password',
					label: 'password',
					value: '',
					type: 'password',
					required: code === false,
				});
			}

			if (code) {
				_userData.push({
					index: 'code',
					label: 'Código de acceso',
					value: '',
					type: 'text',
				});
			}

			(subscribersTemplate || []).forEach((row) => {
				_userData.push({
					index: row.index,
					label: row.index,
					value: '',
					type: 'text',
				});
			});

			return (
				<View
					uid={''}
					icon={_AVATAR_}
					title={'Crear suscriptor'}
					showPassword={showPassword}
					handleShowPassword={handleShowPassword}
					subscribersTemplate={subscribersTemplate}
					onSave={onSave}
					isNew={true}
					code={code}
					email={email}
					isLoading={isLoading}
					isVisible={isVisible}
					userData={_userData}
					onChangePhoto={onChangePhoto}
					hide={hide}
				/>
			);
		}

		const _requiredFields = [
			{
				name: 'displayName',
				type: 'text',
				required: true,
			},
		];

		_requiredFields.push({ name: 'email', type: 'email' });
		if (event.privacity !== 'PUBLIC') {
			if (email) {
				_requiredFields.push({ name: 'password', type: 'password' });
			}

			if (code) {
				_requiredFields.push({ name: 'code', type: 'text' });
			}
		}
		_requiredFields.forEach((field) => {
			const record = userData.filter((rec) => rec.index === field.name);
			if (record.length > 0) {
				_userData.push({
					index: field.name,
					label: field.name,
					value: record[0].value,
					type: field.type,
				});
			} else {
				_userData.push({
					index: field.name,
					label: field.name,
					value: '',
					type: field.type,
				});
			}
		});

		(subscribersTemplate || []).forEach((row) => {
			const record = userData.filter((rec) => rec.index === row.index);
			if (record.length > 0) {
				_userData.push({
					index: row.index,
					label: row.index,
					value: record[0].value,
					type: row.type,
				});
			} else {
				_userData.push({
					index: row.index,
					label: row.index,
					value: '',
					type: row.type,
				});
			}
		});

		return (
			<View
				uid={selectedUser.id}
				blockName={blockName}
				icon={selectedUser.photoURL}
				title={selectedUser.displayName}
				showPassword={showPassword}
				handleShowPassword={handleShowPassword}
				subscribersTemplate={subscribersTemplate}
				onSave={onSave}
				code={code}
				email={email}
				isLoading={isLoading}
				isVisible={isVisible}
				userData={_userData}
				onChangePhoto={onChangePhoto}
				hide={hide}
			/>
		);
	}

	return null;
};

export default SubscriberData;
